import React from "react";
import styled from "styled-components";
import { NavLink, Link } from "react-router-dom";
import BaseComponent from "../../BaseComponent.js";
import NanoFlex from "../../Global/NanoFlex.js";
import Type from "../../Global/Typography.js";

//COMPONENTS
import MenuBurguer from "../../Animations/MenuBurguer.js";
import SimpleButton from "../../Buttons/SimpleButton.js";

//Imgs
import { ReactComponent as ChaseUpLogo } from "./../../Global/images/chaseupLogo.svg";
import { ReactComponent as ArrowBottom } from "./../../Global/icons/arrowBottom.svg";

const StyledNavBar = styled(NanoFlex)`
  height: auto;
  user-select: none;
  margin-bottom: 32px;

  .navbar {
    height: auto;
    background-color: ${(props) => props.theme.color.main.white};
    padding: 10px 150px;
    position: relative;
    z-index: 9;

    @media only screen and (max-width: 1450px) {
      padding: 5px 100px;
    }

    @media only screen and (max-width: 1024px) {
      padding: 5px 60px;
      gap: 16px;
    }

    @media only screen and (max-width: 815px) {
      padding: 5px 50px;
    }

    .brandContainer {
      width: auto;
      a {
        svg {
          width: auto;
          height: 37px;

          @media only screen and (max-width: 1024px) {
            height: 30px;
          }
          @media only screen and (max-width: 815px) {
            height: 26px;
          }
        }
      }
    }
    .navbarItemsContainer {
      display: ${(props) => (props.formationDetail ? "none" : "flex")};
      gap: 30px;
      .navbarList {
        gap: 30px;

        .navbarItem {
          width: auto;
          a {
            text-decoration: none;

            p {
              color: ${(props) => props.theme.color.primaryColors.fontColor};
            }

            svg {
              height: 18px;
              width: auto;
            }
            &:hover {
              p {
                transition: ${(props) => props.theme.transition};
                color: ${(props) => props.theme.color.primaryColors.darkPurple};
              }
              svg {
                path {
                  transition: ${(props) => props.theme.transition};
                  fill: ${(props) => props.theme.color.primaryColors.darkPurple};
                }
              }
            }
          }
          .activeNavItem {
            pointer-events: none;
            p {
              color: ${(props) => props.theme.color.primaryColors.darkPurple};
            }
          }
        }
        .iconNavItem {
          margin-right: 16px;
          &:last-child {
            margin-right: 0;
          }
        }
      }
      .languagesList {
        width: auto;
        position: relative;

        .hide {
          display: none;
        }
        .langItem {
          cursor: pointer;
          gap: 8px;

          &:last-child {
            margin-right: 0;
          }

          p {
            color: ${(props) => props.theme.color.primaryColors.darkPurple};
            display: none;

            &.active {
              display: flex;
            }
          }

          svg {
            height: 18px;
            width: 18px;
            transform: rotate(0deg);
            transition: ${(props) => props.theme.transition};

            path {
              stroke: ${(props) => props.theme.color.primaryColors.darkPurple};
            }
          }

          &.openTab {
            svg {
              transform: rotate(-180deg);
            }
          }
        }

        .languageTabOptions {
          position: absolute;
          right: 0px;
          height: auto;
          width: 100px;
          background-color: ${(props) => props.theme.color.primaryColors.white};
          top: 49px;
          border-radius: 0px;
          border-radius: 10px;
          overflow: hidden;
          box-shadow: ${(props) => props.theme.boxShaddow};
          transition: ${(props) => props.theme.transition};

          @media only screen and (max-width: 1450px) {
            top: 35px;
          }

          .tabOption {
            padding: 7px 10px;
            cursor: pointer;
            transition: ${(props) => props.theme.transition};

            p {
              color: ${(props) => props.theme.color.primaryColors.fontColor};
            }

            &:hover {
              background-color: ${(props) => props.theme.color.primaryColors.mediumPurple};

              p {
                color: ${(props) => props.theme.color.primaryColors.white};
              }
            }

            &.activeTab {
              background-color: ${(props) => props.theme.color.primaryColors.darkPurple};
              pointer-events: none;

              p {
                color: ${(props) => props.theme.color.primaryColors.white};
              }
            }
          }
        }
      }
    }
    .formationTitle {
      display: ${(props) => (props.formationDetail ? "flex" : "none")};
      h4 {
        text-transform: uppercase;
      }
    }
    .navMobile {
      display: none;
    }
  }

  /* FIXED NAVBAR */
  .fixedNav {
    z-index: 9;
    position: fixed;
    top: 0;
    transition: ${(props) => props.theme.transition};
    padding: 10px 150px;

    @media only screen and (max-width: 1450px) {
      padding: 5px 100px;
    }

    @media only screen and (max-width: 1024px) {
      padding: 5px 60px;
    }
    @media only screen and (max-width: 815px) {
      padding: 5px 50px;
    }
  }

  /* MEDIA QUERIES */
  @media only screen and (max-width: 1450px) {
    .navbar {
      padding: 5px 100px;
    }
  }

  @media only screen and (max-width: 1024px) {
    .navbar {
      padding: 5px 80px;
      gap: 16px;
    }
  }

  @media only screen and (max-width: 815px) {
    .navbar {
      padding: 5px 40px;
      .brandContainer {
        width: auto;
      }
      .navbarItemsContainer {
        display: none;
      }
      .navMobile {
        display: ${(props) => (props.formationDetail ? "none" : "flex")};
      }
    }
  }

  @media only screen and (max-width: 390px) {
    .navbar {
      padding: 5px 36px;
    }
  }
`;

export class NavBar extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      fixedNav: null,
      isLanguageOpen: false,
    };
  }

  // FIXED NAVBAR
  componentDidMount() {
    super.componentDidMount();
    window.addEventListener("scroll", () => {
      let fixedNav = "normal";
      if (window.scrollY === 0) {
        fixedNav = null;
      } else {
        fixedNav = "top";
      }
      this.setState({ fixedNav });
    });

    window.addEventListener("click", () => {
      this.setState({ isLanguageOpen: false });
    });
  }
  // END FIXED NAVBAR

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  scrollToTop = (v) => {
    // window.scrollTo(0, 0);
    this.setState({ selected: v });
  };

  //LANGUAGUE
  onHeaderLanguageChange = () => {
    this.getAllComponentsData();
  };

  openLanguage = (e) => {
    this.setState({ isLanguageOpen: !this.state.isLanguageOpen });
    e.stopPropagation();
  };

  changeLanguage = (langId) => {
    window.dispatchEvent(new CustomEvent("languageChange", { detail: langId }));
    this.setState({ isLanguageOpen: false });
  };
  //END LANGUAGUE

  //MENU BURGER
  onMenuBurgerOpenChange = (val) => {
    if (this.props.onMenuBurgerOpenChange) this.props.onMenuBurgerOpenChange(val);
  };
  //END MENU BURGER

  render() {
    let langId = this.getLanguage();

    return (
      <StyledNavBar className="navBar" justifyContent="space-between" alignItems="flex-start" formationDetail={this.props.formationDetail}>
        <NanoFlex className={`navbar ${this.state.fixedNav ? "fixedNav" : ""}`}>
          <NanoFlex className="brandContainer">
            <NavLink to="/">
              <ChaseUpLogo />
            </NavLink>
          </NanoFlex>
          <NanoFlex className="navbarItemsContainer" justifyContent="flex-end">
            <NanoFlex className="navbarList" justifyContent="flex-end">
              <NanoFlex className="navbarItem">
                <NavLink to="/about-us" exact={true} activeClassName="activeNavItem">
                  <Type.p>{this.translation.navBar.aboutUs}</Type.p>
                </NavLink>
              </NanoFlex>
              {/*<NanoFlex className="navbarItem">
                <NavLink to="" activeClassName="">
                  <Type.p>{this.translation.navBar.Method}</Type.p>
                </NavLink>
              </NanoFlex>*/}

              <NanoFlex className="navbarItem">
                <NavLink to="/recrutamento" activeClassName="activeNavItem">
                  <Type.p>{this.translation.navBar.recruitment}</Type.p>
                </NavLink>
              </NanoFlex>
              <NanoFlex className="navbarItem">
                <NavLink to="/assessment" activeClassName="activeNavItem">
                  <Type.p>{this.translation.navBar.assessment}</Type.p>
                </NavLink>
              </NanoFlex>
              <Link to="#contacts">
                <SimpleButton darkPurple label={this.translation.navBar.sayHi}></SimpleButton>
              </Link>
            </NanoFlex>
            <NanoFlex className="languagesList">
              <NanoFlex className={`langItem ${this.state.isLanguageOpen ? "openTab" : ""}`} onClick={(e) => this.openLanguage(e)}>
                <Type.p className={` ${langId === null ? "active" : ""}`}>PT</Type.p>
                <Type.p className={` ${langId === 2 ? "active" : ""}`}>EN</Type.p>
                <ArrowBottom />
              </NanoFlex>
              {this.state.isLanguageOpen && (
                <NanoFlex className="languageTabOptions" flexDirection="column">
                  <NanoFlex className={`tabOption ${langId === null ? "activeTab" : ""}`} justifyContent="flex-start" onClick={() => this.changeLanguage(null)}>
                    <Type.p>PT</Type.p>
                  </NanoFlex>
                  <NanoFlex className={`tabOption ${langId === 2 ? "activeTab" : ""}`} justifyContent="flex-start" onClick={() => this.changeLanguage(2)}>
                    <Type.p>EN</Type.p>
                  </NanoFlex>
                </NanoFlex>
              )}
            </NanoFlex>
          </NanoFlex>
          <NanoFlex className="navMobile" justifyContent="flex-end">
            <MenuBurguer open={this.props.menuBurgerOpen} onOpenChange={this.onMenuBurgerOpenChange} />
          </NanoFlex>
        </NanoFlex>
      </StyledNavBar>
    );
  }
}
